module.exports = __webpack_public_path__ + "static/media/testimonialPics.d872e04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonialPics.png
// module id = 342
// module chunks = 0